import * as yup from 'yup';

export const profileSchema = yup.object().shape({
  firstName: yup.string(),
  lastName: yup.string(),
  phone: yup.string(),
  countryCode: yup.string(),
  email: yup.string(),
  tfnNumber: yup.string(),
  hashTFNNumber: yup.string(),
  citizenship: yup.string(),
  taxResidencyStatus: yup.string(),
});
